import React from 'react';
import BasePage from './BasePage';
import { connect } from 'react-redux';
import {setMenu,setModalContent} from '../actionCreators';
import Menu from '../components/Menu';
import Modal from '../components/Modal';
import FileUploader from '../components/FileUploader';
import $ from 'jquery';

class EditClient extends BasePage {

    loadOnConstructor(){
	this.getClient = this.getClient.bind(this);
	this.cancelButton = this.cancelButton.bind(this);
	this.saveButton = this.saveButton.bind(this);
	this.updateClientCallback = this.updateClientCallback.bind(this);
	this.newClientCallback = this.newClientCallback.bind(this);
	this.handleChange = this.handleChange.bind(this);
	this.renderContactModes = this.renderContactModes.bind(this);
	this.addContactMode = this.addContactMode.bind(this);
	this.deleteContactMode = this.deleteContactMode.bind(this);
	this.altTab = this.altTab.bind(this);
	this.openScheduleCard = this.openScheduleCard.bind(this);
	this.openScheduleInfo = this.openScheduleInfo.bind(this);
	this.renderEditSchedule = this.renderEditSchedule.bind(this);
	this.changeScheduleCallback = this.changeScheduleCallback.bind(this);
	this.determineAction = this.determineAction.bind(this);
	this.sendUploadFile = this.sendUploadFile.bind(this);

	this.showAddFileWindow = this.showAddFileWindow.bind(this);
	this.downloadFile = this.downloadFile.bind(this);
	this.downloadFileCallback = this.downloadFileCallback.bind(this);
	this.deleteFile = this.deleteFile.bind(this);
	this.deleteFileConfirmed = this.deleteFileConfirmed.bind(this);
	this.deleteFileCallback = this.deleteFileCallback.bind(this);
	this.openBill = this.openBill.bind(this);
	this.openArticle = this.openArticle.bind(this);

	this.uploadFile = React.createRef();

	this.determineAction();
    }

    determineAction(){
	const {client_id} = this.getUrlParams();
	if(client_id !== undefined){
		this.state = {action: 'modify', client_id: client_id};
		this.getClient(client_id);
	}else{
		this.state = {action: 'new'};
		this.getClient();
	}

    }

    getClient(clientId){
	const api = this.getApi();
	api.getEditClientInterface(clientId, (response) => {

		if(response.hasOwnProperty('auth') && response.auth === false){
			this.navigateTo('/login');
			return;
		}

		for(let prop in response.client){
			if(response.client[prop] === 'null') response.client[prop] = '';
		}

		response.schedules.map(schedule => {

			const date = new Date(schedule.start_date);
			const dateString =
			("0" + date.getUTCDate()).slice(-2) + "/" +
			("0" + (date.getUTCMonth()+1)).slice(-2) + "/" +
			date.getUTCFullYear() + " " +
			("0" + date.getUTCHours()).slice(-2) + ":" +
			("0" + date.getUTCMinutes()).slice(-2);
			
			schedule.formatted_start_date = dateString;
			return schedule;
		});

		this.setState(prevState => {
			return {
			...prevState,
			client: response.client,
			locations: response.locations || [],
			i18n: response.i18n,
			schedules: response.schedules,
			bills: response.bills || [],
			articles: response.articles || [],
			files: response.files || []
		}});
	});
    }

    cancelButton(){
	this.goBack();
    }

    saveButton(){

	let failedValidators = {};
	if($('#name').val() === ''){
		failedValidators.name = this.getTrad('fillNameField');
	}

	if($('#mobile_0').length === 0 && $('#landline_0').length === 0 && $('#email_0').length === 0){
		failedValidators.contactModes = this.getTrad('fillContactMode');
	}
	if(Object.keys(failedValidators).length !== 0){
		let message = [];
		for (let m in failedValidators){
			message.push(failedValidators[m]);
		}
		this.props.setModalContent({
			title: this.getTrad('fillAllMandatoryFields'),
			body: message,
			buttons: [
				{shown: 'Aceptar', behaviour: 'main', close: true}
			]
		});

		$("#exampleModal").modal('toggle');
		return;
	}

	let prevState = JSON.parse(JSON.stringify(this.state.client));

	if(prevState.mobile){ 
		for(const mob of prevState.mobile){
			if(!(""+mob).match(/^\+?[0-9]{9,}$/)){
				this.props.setModalContent({
					title: this.getTrad('validationError'),
					body: [this.getTrad('contactModeIncorrect')],
					buttons: [
						{shown: 'Aceptar', behaviour: 'main', close: true }
					]
				});

				$("#exampleModal").modal('toggle');
				return;
			}
		}
		prevState.mobile = prevState.mobile.join();
	}else{
		prevState.mobile = "";
	}

	if(prevState.landline){ 
		for(const land of prevState.landline){
			if(!(""+land).match(/^\+?[0-9]{9,}$/)){
				this.props.setModalContent({
					title: this.getTrad('validationError'),
					body: [this.getTrad('contactModeIncorrect')],
					buttons: [
						{shown: 'Aceptar', behaviour: 'main', close: true }
					]
				});

				$("#exampleModal").modal('toggle');
				return;
			}
		}
		prevState.landline = prevState.landline.join();
	}else{
		prevState.landline = "";
	}

	if(prevState.email){ 
		for(const em of prevState.email){
			if(!em.match(/^[a-zA-Z0-9_\-.]+@[a-zA-Z0-9_-]+\.[a-zA-Z0-9]+(\.[a-zA-Z0-9]+)?$/)){
				this.props.setModalContent({
					title: this.getTrad('validationError'),
					body: [this.getTrad('contactModeIncorrect')],
					buttons: [
						{shown: 'Aceptar', behaviour: 'main', close: true }
					]
				});

				$("#exampleModal").modal('toggle');
				return;
			}
		}
		prevState.email = prevState.email.join();
	}else{
		prevState.email = "";
	}

	const api = this.getApi();

	if(this.state.action === 'modify'){
	    	api.updateClient(prevState,this.updateClientCallback);
	}else{
	    	api.newClient(prevState,this.newClientCallback);
	}

	let clientPreviousState = prevState;

	clientPreviousState.mobile = clientPreviousState.mobile? clientPreviousState.mobile.split(","):[];
	clientPreviousState.landline = clientPreviousState.landline? clientPreviousState.landline.split(","):[];
	clientPreviousState.email = clientPreviousState.email? clientPreviousState.email.split(","):[];

	this.setState(prevState => {
		return {
			...prevState,
			client: clientPreviousState
		}
	});
    }

    updateClientCallback(response){
    	if(response.status === 'OK'){
    	this.props.setModalContent({
		title: this.getTrad('messageFromServer'),
		body: [this.getTrad('clientModifiedSuccessfully')],
		buttons: [
			{shown: 'Aceptar', behaviour: 'main', close: true, callback: this.goBack}
		]
	});

	$("#exampleModal").modal('toggle');
	}else{
		this.props.setModalContent({
			title: this.getTrad('messageFromServer'),
			body: [this.getTrad(response.message)],
			buttons: [
			    {shown: 'Aceptar', behaviour: 'main', close: true, callback: this.goBack}
			]
		});

		$("#exampleModal").modal('toggle');

	}
    }

    newClientCallback(response){
	if(response.status !== 'OK'){

		this.props.setModalContent({
			title: this.getTrad('messageFromServer'),
			body: [this.getTrad("clientSavedSuccessfully")],
			buttons: [
			    {shown: 'Aceptar', behaviour: 'main', close: true, callback: this.goBack}
			]
		});

		$("#exampleModal").modal('toggle');

	}else{
		this.props.setModalContent({
			title: this.getTrad('messageFromServer'),
			body: [this.getTrad('clientCreatedSuccessfully')],
			buttons: [
			    {shown: 'Aceptar', behaviour: 'main', close: true, callback: this.goBack}
			]
		});

		$("#exampleModal").modal('toggle');
	}
    }

    addContactMode(mode){
    	let clientMod = {};
    	if(this.state.client){
		clientMod = this.state.client;
	}

	if(!clientMod[mode]){
		clientMod[mode] = [];
	}

	clientMod[mode].push("");
	
	this.setState(prevState => {
		return {
			...prevState,
			client: clientMod
		}
	});
    }

    deleteContactMode(contactMode, id){

	let clientMod = {...this.state.client};
	const newModes = clientMod[contactMode].filter((element, idx) =>  idx !== id);

	clientMod[contactMode] = newModes
	
	this.setState(prevState => {
		return {
			...prevState,
			client: clientMod
		}
	});
    }

    handleChange(event) {
	let clientMod = {...this.state.client};
	if(event.target.name.match(/mobile/)){
		const parts = event.target.name.split('_');

		if(!event.target.value.match(/^\+?[0-9]{9,}$/)){
			this.props.setModalContent({
				title: this.getTrad('validationError'),
				body: [this.getTrad('contactModeIncorrect')],
				buttons: [
				    {shown: 'Aceptar', behaviour: 'main', close: true }
				]
			});

			$("#exampleModal").modal('toggle');
		}

		if(clientMod.mobile[parts[1]] !== undefined){
			clientMod.mobile[parts[1]] = event.target.value;
		}else{
			clientMod.mobile.push(event.target.value);
		}
	}else if(event.target.name.match(/landline/)){
		const parts = event.target.name.split('_');

		if(!event.target.value.match(/^\+?[0-9]{9,}$/)){
			this.props.setModalContent({
				title: this.getTrad('validationError'),
				body: [this.getTrad('contactModeIncorrect')],
				buttons: [
				    {shown: 'Aceptar', behaviour: 'main', close: true }
				]
			});

			$("#exampleModal").modal('toggle');
		}


		if(clientMod.landline[parts[1]] !== undefined){
			clientMod.landline[parts[1]] = event.target.value;
		}else{
			clientMod.landline.push(event.target.value);
		}

	}else if(event.target.name.match(/email/)){
		const parts = event.target.name.split('_');

		if(!event.target.value.match(/^[a-zA-Z0-9_\-.]+@[a-zA-Z0-9_-]+\.[a-zA-Z0-9]+(\.[a-zA-Z0-9]+)?$/)){
			this.props.setModalContent({
				title: this.getTrad('validationError'),
				body: [this.getTrad('contactModeIncorrect')],
				buttons: [
				    {shown: 'Aceptar', behaviour: 'main', close: true }
				]
			});

			$("#exampleModal").modal('toggle');
		}

		if(clientMod.email[parts[1]] !== undefined){
			clientMod.email[parts[1]] = event.target.value;
		}else{
			clientMod.email.push(event.target.value);
		}

	}else if(event.target.name === 'status'){

		let schMod = this.state.scheduleSelected;
		schMod.status = event.target.value;
		this.setState(prevState => {
			return {
			...prevState,
			scheduleSelected: schMod
		}});
	}else{
		clientMod[event.target.name] = event.target.value;
	}

	this.setState(prevState => {
		return {
		...prevState,
		client: clientMod
	}});
    }

    renderContactModeBlock(contactMode, contactModeArray){
    	    return contactModeArray && contactModeArray.length>0 && contactModeArray.map?contactModeArray.map((elem,idx) => {
		return <div className="row" key={"row_contact_mode_"+idx+"_"+elem}>
			<div className="col-4">
				<div className="form-group">
					<input type={contactMode === 'email'?contactMode:'text'} className="form-control" 
					id={contactMode+"_"+idx} name={contactMode+"_"+idx}
					    defaultValue={this.state.client?elem:''} onBlur={this.handleChange}/>
				</div>
			</div>
			<div className="col-4">
				  <div className="d-flex align-items-center mb-2">
					  <button type="button" className="btn btn-primary ml-2" 
					  onClick={() => {this.deleteContactMode(contactMode, idx)}}>-</button>
				  </div>
			</div>
		</div>

	}):""
    }

    renderContactModes(){
	    return (
	    	<>
	    	<div className="row">
	    		<div className="col-3">{this.getTrad("mobiles")}</div>
	    		<div className="col-1">
	    			  <div className="d-flex align-items-center mb-2">
					  <button type="button" className="btn btn-primary" onClick={() => {this.addContactMode('mobile')}}>+</button>
				  </div>
	    		</div>
	    	</div>
		{this.renderContactModeBlock("mobile", this.state.client?this.state.client.mobile:[])}
	    	<div className="row">
	    		<div className="col-3">{this.getTrad("landlines")}</div>
	    		<div className="col-1">
	    			  <div className="d-flex align-items-center mb-2">
					  <button type="button" className="btn btn-primary" onClick={() => {this.addContactMode('landline')}}>+</button>
				  </div>
	    		</div>
	    	</div>

		{this.renderContactModeBlock("landline", this.state.client?this.state.client.landline:[])}
	  	<div className="row">
	    		<div className="col-3">{this.getTrad("emails")}</div>
	    		<div className="col-1">
	    			  <div className="d-flex align-items-center mb-2">
					  <button type="button" className="btn btn-primary" onClick={() => {this.addContactMode('email')}}>+</button>
				  </div>
	    		</div>
	    	</div>
		{this.renderContactModeBlock("email", this.state.client?this.state.client.email:[])}
	    	</>   
	    )
    }

    altTab(tabId){
	const tabs = ['principal', 'citas','ficheros', 'facturas', 'articulos'];

	for (let tab in tabs){
		$('#'+tabs[tab]).css("display", "none");
		$('#'+tabs[tab]+"Tab").removeClass("active");
	}

	$('#'+tabId).css("display", "block");
	$('#'+tabId+"Tab").addClass("active");
	//aria-current="page"
    }

    openScheduleCard(arrayPosition){
	const schedule = this.state.schedules[arrayPosition];

	this.setState(prevState => {
		return {
			...prevState,
			scheduleSelected: schedule
		}
	},
	this.openScheduleInfo);

    }

    openScheduleInfo(){
	    $("#editSchedule").modal('toggle');
    }

    changeScheduleCallback(response){
	if(response.status === 'OK'){
		this.props.setModalContent({
			title: this.getTrad('messageFromServer'),
			body: [this.getTrad('ScheduleModifiedSuccessfully')],
			buttons: [
				{shown: 'Aceptar', behaviour: 'main', close: true}
			]
		});

		$("#exampleModal").modal('toggle');

		//Reload schedules from server
		this.determineAction();
	}
    }

    formatDateToUserString(dateString){
console.log(dateString, typeof dateString)
	return dateString.substring(8,10)+'/'+dateString.substring(5,7)+'/'+dateString.substring(0,4)+' '+
	    	dateString.substring(11,13)+':'+dateString.substring(14,16);
    }

    renderEditSchedule(){
    	    const sch = this.state.scheduleSelected;

	return (<div className="row">
		<div className="col-12">
			<form>
				<div className="form-group">
					<label htmlFor="title">{this.getTrad("scheduleTitle")}</label>
					<input type="text" className="form-control" id="title" name="title"
					defaultValue={sch?sch.title:''} disabled />
				</div>
				<div className="form-group">
					<label htmlFor="start_date">{this.getTrad("startDate")}</label>
					<input type="text" className="form-control" id="start_date" name="start_date"
					defaultValue={sch?this.formatDateToUserString(sch.start_date):''} disabled />
				</div>
				<div className="form-group">
					<label htmlFor="end_date">{this.getTrad("endDate")}</label>
					<input type="text" className="form-control" id="end_date" name="end_date"
					defaultValue={sch?this.formatDateToUserString(sch.end_date):''} disabled />
				</div>
				<div className="form-group">
					<label htmlFor="assigned_user">{this.getTrad("user")}</label>
					<input type="text" className="form-control" id="assigned_user" name="assigned_user"
					defaultValue={sch?sch.assigned_user.name+' '+sch.assigned_user.lastname:''} disabled />
				</div>
				<div className="form-group">
					<label htmlFor="comments">{this.getTrad("description")}</label>
					<textarea className="form-control" id="comments" name="description"
					defaultValue={sch?sch.description:''} disabled />
				</div>
				<div className="form-group">
					<label htmlFor="status">{this.getTrad("scheduleStatus")}</label>
					<select className="form-control" id="status" name="status"
					defaultValue={sch?sch.status:''} onChange={this.handleChange}>
						<option value="1" selected={sch && sch.status === 1?true:undefined} >
							{this.getTrad("planned")}
						</option>
						<option value="2" selected={sch && sch.status === 2?true:undefined}>
							{this.getTrad("reportedFinished")}
						</option>
						<option value="3" selected={sch && sch.status === 3?true:undefined}>
							{this.getTrad("reportedCanceled")}
						</option>
					</select>
				</div>
			</form>
		</div>
    	</div>)
    }


    showAddFileWindow(){
	this.props.setModalContent({
	    title: this.getTrad('addFile'),
	    body: [
	    	(<FileUploader ref={this.uploadFile}  onSendFile={this.sendUploadFile} aditionalFields={[{name: 'client', value: this.state.client_id }]} />)
	    ],
	    buttons: [
		    {shown: 'Aceptar', behaviour: 'main', callback:() => {this.uploadFile.current.sendForm()}, close: true},
		    {shown: 'Cancelar', close: true}
	    ]
	});

	$("#exampleModal").modal('toggle');
    }

    sendUploadFile(response){
	if(response.status === 'OK'){

	    let currFiles = JSON.parse(JSON.stringify(this.state.files)); 
	    currFiles.unshift(response.file);

	    this.setState(prevState => {
		return {
		    ...prevState,
		    files: currFiles
		}
	    });
	}
	
    }

    downloadFile(fileId){
	const api = this.getApi();

	this.setState(prevState => {
		return {
			...prevState,
		    	downloadFile: this.state.files.filter(file => file._id === fileId).pop()
		}
	},api.downloadFile(fileId, this.downloadFileCallback));
    }

    downloadFileCallback(response){

		const newBlob = new Blob([response], { type: 'application/octet-stream' });

		if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            		window.navigator.msSaveOrOpenBlob(newBlob);
       		} else {
            		// For other browsers: create a link pointing to the ObjectURL containing the blob.
            		const objUrl = window.URL.createObjectURL(newBlob);

            		let link = document.createElement('a');
            		link.href = objUrl;
            		link.download = this.state.downloadFile.name;
            		link.click();

            		// For Firefox it is necessary to delay revoking the ObjectURL.
            		setTimeout(() => { window.URL.revokeObjectURL(objUrl); }, 1000);
        	}

		this.setState(prevState => {
			return {
				...prevState,
				downloadFile: undefined
			}
		});
    }

	openBill(billId){
		this.navigateTo('/edit_bill?bill_id='+billId)
	}

	openArticle(articleId){
		this.navigateTo('/edit_article?article_id='+articleId)
	}

    deleteFile(fileId){
	this.props.setModalContent({
	    title: this.getTrad('deleteFile'),
	    body: [this.getTrad('AreYouSureYouWantToDeleteFile')],
	    buttons: [
	    {shown: 'Aceptar', behaviour: 'main', close: true, callback: () => {this.deleteFileConfirmed(fileId)}},
	    {shown: 'Cancelar', close: true}
	    ]
	});

	$("#exampleModal").modal('toggle');
    }

    deleteFileConfirmed(fileId){
    	const api = this.getApi();
    	this.setState(prevState => {
		return {
			...prevState,
		    	fileToRemove: fileId
		}
	},api.deleteFile(fileId, this.deleteFileCallback));
    }

    deleteFileCallback(response){
	let currFiles = JSON.parse(JSON.stringify(this.state.files)); 

	if(response.status === 'OK'){
		this.setState(prevState => {
			return {
				...prevState,
			    	files: currFiles.filter(file => {
					return file._id !== this.state.fileToRemove
				})
			}
		});
	}
    }



	dateToString(dateObject, returnObject){
		const multiplier = 1
		const hoursFromTimezoneOffset = (dateObject.getTimezoneOffset() * multiplier) / 60;
		let dateToString = new Date(dateObject.getTime());
		dateToString.setHours(dateObject.getHours() + hoursFromTimezoneOffset);
	
		return returnObject?dateToString:dateToString.toISOString()
	}

    render() {
        return (
            <div className="container">
            	<Menu />
                <h3>{this.getTrad('clientEdition')}</h3>
		<ul className="nav nav-tabs">
			<li className="nav-item">
				<a id="principalTab" className="nav-link active" aria-current="page" href="dummie" 
					onClick={(e) => { e.preventDefault(); this.altTab('principal') }}>
					Principal
				</a>
			</li>
			{this.state.action !== 'new'?
			<>
			<li className="nav-item">
				<a id="citasTab" className="nav-link" href="dummie" 
					onClick={(e) => { e.preventDefault(); this.altTab('citas')}}>
					Citas
				</a>
			</li>
			<li className="nav-item">
				<a id="ficherosTab" className="nav-link" href="dummie" 
					onClick={(e) => { e.preventDefault(); this.altTab('ficheros')}}>
					Ficheros
				</a>
			</li>
			<li className="nav-item">
				<a id="facturasTab" className="nav-link" href="dummie" 
					onClick={(e) => { e.preventDefault(); this.altTab('facturas')}}>
					Facturas
				</a>
			</li>
			<li className="nav-item">
				<a id="articulosTab" className="nav-link" href="dummie" 
					onClick={(e) => { e.preventDefault(); this.altTab('articulos')}}>
					Artículos
				</a>
			</li>
			</>:undefined}
		</ul>

		{/*Comienzo tab Principal*/}
                <div className="row mt-4" id="principal" style={{display:'block'}}>
			<div className="col-12">
				<form>
				  <div className="form-group">
				    <label htmlFor="name">Nombre</label>
				    <input type="text" className="form-control" id="name" name="name"
				    defaultValue={this.state.client?this.state.client.name:''} onChange={this.handleChange} />
				  </div>
				  <div className="form-group">
				    <label htmlFor="lastname">Apellidos</label>
				    <input type="text" className="form-control" id="lastname" name="lastname"
				    defaultValue={this.state.client?this.state.client.lastname:''} onChange={this.handleChange} />
				  </div>
				  <div className="form-group">
				    <label htmlFor="dni">DNI/NIF</label>
				    <input type="text" className="form-control" id="dni" name="dni"
				    defaultValue={this.state.client?this.state.client.dni:''} onChange={this.handleChange} />
				  </div>
				  <div className="form-group">
				    <label htmlFor="complete_direction">{this.getTrad("completeDirection")}</label>
				    <input type="text" className="form-control" id="complete_direction" name="complete_direction"
				    defaultValue={this.state.client?this.state.client.complete_direction:''} onChange={this.handleChange} />
				  </div>
				  <div className="form-group">
						<label htmlFor="location">Delegación</label>
						<select className="form-control" id="location" name="location"
						defaultValue={this.state.client?this.state.client.location:''} onChange={this.handleChange}>
							<option value ='' selected={this.state.client?.location?.length>4?true:undefined}>Seleccione una opción</option>
							{this.state.locations?.map(loc => {
								return <option key={loc._id} value={loc._id} selected={String(this.state.client?.location) === String(loc._id)?true:undefined}>
									{loc.name}
								</option>
							})}
						</select>
					</div>
				  <div className="form-group">
				  	<label data-toggle="collapse" 
				  	data-target="#contactModesTab" aria-expanded="false" aria-controls="contactModesTab" style={this.expandTab}>
				      		Modos de contacto
				        </label>
				  </div>
				  <div className="collapse" id="contactModesTab">
				  	{this.renderContactModes()}
				  </div>
				  <div className="form-group">
				    <label htmlFor="comments">{this.getTrad("comments")}</label>
				    <textarea className="form-control" id="comments" name="comments"
				    defaultValue={this.state.client?this.state.client.comments:''} 
				    onChange={this.handleChange}></textarea>
				  </div>
				</form>
			</div>
                </div>
		{/*Final tab Principal*/}

		{/*Comienzo tab citas*/}
		<div className="row mt-4 mb-3" id="citas" style={{display:'none'}}>
			<div className="col-12">

				{
					
				this.state.schedules?this.state.schedules.map((schedule,idx) => {
					let color = '';
					let status = '';
					switch(schedule.status){
						case 3:
							//Reportado como cancelada
							status = 'Cancelado';
							color = 'secondary';
							break;
						case 2:
							//Reportado como finalizada
							status = 'Finalizado';
							color = 'success';
							break;
						case 1:
						default:
							color = 'info';
							status = 'Planificado';
							let date = new Date();
							let scheduleDate = new Date(schedule.end_date);
							const hoursFromTimezoneOffset = (date.getTimezoneOffset()*-1) / 60;

							scheduleDate.setHours(scheduleDate.getHours()-hoursFromTimezoneOffset);

							if(date.getTime() >= scheduleDate.getTime()){
								color = 'danger';
								status = 'No reportado';
							}
							break;
					}
					return (<div className={"card w-100 mb-2 border-"+color} key={'schedule_'+schedule._id}
						onClick={() => this.openScheduleCard(idx)} style={this.cursorPointer}>
						<div className="card-body">
							<h5 className="card-title">
								{schedule.title} 
								<span className={"badge ml-3 badge-"+color}>{status}</span>
							</h5>
							<h6 className="card-subtitle mb-2 text-muted">{schedule.formatted_start_date}</h6>
							<p className="card-text">Usuario: {schedule.assigned_user.name+' '+schedule.assigned_user.lastname}</p>
							<p className="card-text ">{schedule.description}</p>
						</div>
					</div>);
				}):''}

			</div>
		</div>
		{/*Final tab citas*/}

		{/*Comienzo tab ficheros*/}
		<div className="row mt-4 mb-3" id="ficheros" style={{display:'none'}}>
		    <div className="row">
		    	<div className="col-12">

					  <button type="button" className="btn btn-primary mb-2" onClick={this.showAddFileWindow}>Nuevo fichero</button>

			{this.state.files && this.state.files.length>0?this.state.files.map((file,idx) => {
					return (<div className="card w-100 mb-2 border-secondary" key={'file_'+file._id}> 
						<div className="card-body">
							<h5 className="card-title">
								{file.name}
								<span onClick={() => {this.downloadFile(file._id)}} className={"badge ml-3 badge-primary"} style={{cursor:'pointer'}}>Descargar</span>
								<span onClick={() => {this.deleteFile(file._id)}} className={"badge ml-3 badge-secondary"} style={{cursor:'pointer'}}>Eliminar</span>
							</h5>
							<h6 className="card-subtitle mb-2 text-muted">{this.formatDateToUserString(file.creation_date)}</h6>
							<p className="card-text">Usuario: {file.created_by_user.name+' '+file.created_by_user.lastname} </p>
							<p className="card-text ">{file.comments}</p>
						</div>
					</div>);
				}):(<div className="row mt-2"><div className="col-12 text-center">No hay ficheros para mostrar</div></div>)}

		    	</div>
		    </div>
		</div>
		{/*Final tab ficheros*/}

		{/*Comienzo tab facturas*/}
		<div className="row mt-4 mb-3" id="facturas" style={{display:'none'}}>
		    <div className="row">
		    	<div className="col-12">

			{this.state.bills && this.state.bills.length>0?this.state.bills.map((bill,idx) => {
					let status = '';
					switch(parseFloat(bill.status)){
						case 1:
							status = this.getTrad("pendingBillStatus")
							break
						case 2:
							status = this.getTrad("overdueBillStatus")
							break
						case 3:
							status = this.getTrad("collectedBillStatus")
							break
						case 4:
							status = this.getTrad("unpaidBillStatus")
							break
						case 5:
							status = this.getTrad("returnedPayBillStatus")
							break
						default: status = 'Desconocido'
					}

					return (<div className="card w-100 mb-2 border-secondary" key={'bill_'+bill._id}> 
						<div className="card-body" onClick={() => {this.openBill(bill._id)}} style={{cursor:'pointer'}}>
							<h5 className="card-title">
								{bill.type === 1?'Factura':'Factura rectificativa'}
								<span className={"badge ml-3 badge-secondary"} >{status}</span>
							</h5>
							<h6 className="card-subtitle mb-2 text-muted">{this.formatDateToUserString(bill.creation_date)}</h6>
							<p className="card-text">Código de factura: {bill.code}</p>
							<p className="card-text">Precio total: {bill.total_price+' €'}</p>
						</div>
					</div>);
				}):(<div className="row mt-2"><div className="col-12 text-center">No hay facturas para mostrar</div></div>)}

		    	</div>
		    </div>
		</div>
		{/*Final tab facturas*/}


		{/*Comienzo tab articulos*/}
		<div className="row mt-4 mb-3" id="articulos" style={{display:'none'}}>
		    <div className="row">
		    	<div className="col-12">

			
			{this.state.articles && this.state.articles.length>0?this.state.articles.map((article,idx) => {
				let status = ''
				let bookingStartDate = ''
				let bookingEndDate = ''
				let bookingFound = false

				let billCode = undefined

				let foundBills = []
				this.state.bills?.forEach(bill => {
					let foundArticles = bill.lines?.filter(line => line.article === article._id)
					if(foundArticles.length > 0) foundBills.push(bill)
				})

				if(foundBills.length >= 1) billCode = foundBills[foundBills.length-1].code

				const now = new Date()
				article.bookings.forEach(bk => {
					if(!bookingFound && (bk.booking_status === 5 || 
						(now.getTime() <= new Date(bk.end_date) && now.getTime() >= new Date(bk.start_date))
						)){
						bookingFound = true
						status = bk.booking_status
						bookingStartDate = bk.start_date
						bookingEndDate = bk.end_date
					}
				})

					switch(parseFloat(status)){
						case 1: status = this.getTrad("availableStatus");break
						case 2: status = this.getTrad("occupedStatus");break
						case 3: status = this.getTrad("repairingStatus");break
						case 4: status = this.getTrad("rentedStatus");break
						case 5: status = this.getTrad("soldStatus");break
						default: status = 'Desconocido'
					}

					return (<div className="card w-100 mb-2 border-secondary" key={'bill_'+article._id}> 
						<div className="card-body" onClick={() => {this.openArticle(article._id)}} style={{cursor:'pointer'}}>
							<h5 className="card-title">
								{article.name}
								<span className={"badge ml-3 badge-secondary"}>{status}</span>
							</h5>
							<h6 className="card-subtitle mb-2 text-muted">
							{parseFloat(article.status) === 5?"Fecha venta":"Fecha inicio"}: {this.formatDateToUserString(bookingStartDate)}
							</h6>
							{parseFloat(article.status) !== 5 && 
								<h6 className="card-subtitle mb-2 text-muted">
									Fecha fin: {this.formatDateToUserString(bookingEndDate)}
								</h6> 
							}
							<p>Factura: {billCode?billCode:'Sin factura asociada'}</p>
							
						</div>
					</div>);
				}):(<div className="row mt-2"><div className="col-12 text-center">No hay artículos para mostrar</div></div>)}

		    	</div>
		    </div>
		</div>
		{/*Final tab articulos*/}



		<div className="row">
			<div className="col-12">
				  <div className="d-flex justify-content-between align-items-center mb-2">
					  <button type="button" className="btn btn-primary" onClick={this.saveButton}>Guardar</button>
					  <button type="button" className="btn btn-secondary" onClick={this.cancelButton}>Cancelar</button>
				  </div>

			</div>
		</div>


		<div className="modal fade" id="editSchedule" tabIndex="-1" role="dialog" aria-labelledby="editScheduleTitleLabel" aria-hidden="true">
			<div className="modal-dialog" role="document">
				<div className="modal-content">
					<div className="modal-header">
						<h5 className="modal-title" id="editScheduleTitleLabel">
							{this.getTrad('scheduleInfo')}
						</h5>
						<button type="button" className="close" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div className="modal-body">
						{this.renderEditSchedule()}
					</div>
					<div className="modal-footer">
						<button type="button" className="btn btn-primary" data-dismiss="modal"
							onClick={() => {
								const api = this.getApi();
								let schToApi = this.state.scheduleSelected;
								schToApi.assigned_user = schToApi.assigned_user._id;
								api.updateSchedule(schToApi, this.changeScheduleCallback);
								$("#editSchedule").modal('toggle');
								
							}}>
							{this.getTrad("Aceptar")}
						</button>
						<button type="button" className="btn btn-secondary" data-dismiss="modal"
							onClick={() => {
								$("#editSchedule").modal('toggle');
								
							}}>
							{this.getTrad("Cancelar")}
						</button>

					</div>
				</div>
			</div>
		</div>

		<Modal />
            </div>
        );
    }

    cursorPointer = {
	cursor: 'pointer'
    }

    expandTab = {
	cursor: 'pointer',
	width: '100%',
	background: '#CCC',
	padding:'3px',
	fontWeight: 'bold',
	textAlign: 'center'
    }

}

const mapStateToProps = state => {
    return {
        menu: state.menu,
        clients: state.clients
    };
}

const mapDispatchToProps = dispatch => {
    return {
        setMenu(menu){
            dispatch(setMenu(menu));
        },
        setModalContent(modalContent){
	    dispatch(setModalContent(modalContent));
	}
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(EditClient)
